import { Link } from 'react-router-dom';

interface CategoryCard {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
}

const categoryCards: CategoryCard[] = [
  {
    slug: 'core-value',
    name: '核心价值',
    description: '深度解读掌中的美母所承载的内在价值与精神内涵',
    icon: 'ri-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20elegant%20Chinese%20artistic%20scene%20featuring%20soft%20natural%20light%20on%20a%20mother%20holding%20a%20child%20hand%20gently%2C%20traditional%20cultural%20elements%20like%20subtle%20ink%20wash%20painting%20texture%20in%20background%2C%20minimalist%20composition%2C%20muted%20earthy%20tones%20with%20warm%20amber%20highlights%2C%20editorial%20photography%20style%2C%20serene%20and%20emotional%20atmosphere%2C%20soft%20focus%20edges%2C%20harmonious%20and%20refined%20aesthetic&width=800&height=600&seq=category-core-value&orientation=landscape',
  },
  {
    slug: 'usage-scenarios',
    name: '使用场景',
    description: '探索掌中的美母在不同生活场景中的实际应用与体验',
    icon: 'ri-layout-masonry-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20lifestyle%20scene%20showing%20a%20beautifully%20crafted%20handheld%20object%20on%20a%20wooden%20desk%20with%20tea%20set%20nearby%2C%20soft%20diffused%20window%20light%20creating%20gentle%20shadows%2C%20contemporary%20minimalist%20interior%20with%20traditional%20accents%2C%20warm%20neutral%20color%20palette%20with%20terracotta%20and%20cream%20tones%2C%20editorial%20product%20photography%2C%20clean%20and%20sophisticated%20composition%2C%20calm%20and%20peaceful%20mood&width=800&height=600&seq=category-usage&orientation=landscape',
  },
  {
    slug: 'real-experience',
    name: '真实体验',
    description: '来自真实用户的体验分享与深度感受',
    icon: 'ri-user-star-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20intimate%20close-up%20scene%20of%20hands%20gently%20cupping%20a%20delicate%20object%20with%20soft%20natural%20light%20from%20above%2C%20warm%20golden%20hour%20lighting%20creating%20a%20peaceful%20atmosphere%2C%20subtle%20traditional%20Chinese%20cultural%20elements%20in%20the%20blurred%20background%2C%20cream%20and%20soft%20brown%20color%20palette%2C%20editorial%20lifestyle%20photography%2C%20emotional%20and%20tender%20composition%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=category-experience&orientation=landscape',
  },
  {
    slug: 'in-depth-review',
    name: '深度评测',
    description: '专业视角下的全方位分析与解读',
    icon: 'ri-file-search-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20studio%20setup%20with%20a%20beautifully%20lit%20object%20on%20a%20minimalist%20surface%2C%20professional%20photography%20lighting%20creating%20soft%20even%20illumination%2C%20subtle%20Chinese%20cultural%20motifs%20in%20the%20background%20texture%2C%20warm%20neutral%20tones%20with%20amber%20and%20soft%20grey%2C%20clean%20product%20photography%20style%2C%20precise%20and%20elegant%20composition%2C%20refined%20aesthetic&width=800&height=600&seq=category-review&orientation=landscape',
  },
  {
    slug: 'cultural-insight',
    name: '文化洞见',
    description: '从文化视角探寻掌中的美母的深远意义',
    icon: 'ri-book-open-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20artistic%20composition%20featuring%20traditional%20Chinese%20calligraphy%20tools%20and%20a%20delicate%20object%20on%20silk%20fabric%2C%20soft%20natural%20morning%20light%20streaming%20through%20paper%20windows%2C%20ink%20wash%20painting%20style%20textures%2C%20muted%20earthy%20colors%20with%20subtle%20gold%20accents%2C%20cultural%20heritage%20photography%2C%20poetic%20and%20contemplative%20atmosphere%2C%20elegant%20and%20thoughtful%20arrangement&width=800&height=600&seq=category-culture&orientation=landscape',
  },
];

export default function CategorySection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-sm text-accent-600 font-medium tracking-widest mb-3">
            分类探索
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-4">
            选择您感兴趣的方向
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            按照不同维度深入了解掌中的美母，每一个分类都为您打开一扇新的认知之门。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categoryCards.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden h-64"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/80 text-background-50">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  <h3 className="text-lg font-heading text-background-50">{cat.name}</h3>
                </div>
                <p className="text-sm text-background-100/80 leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}